"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _utils = require("../../utils");
var _composeStencilComponent = require("../../utils/composeStencilComponent");
var _helperComponents = require("./helperComponents");
var _react2 = require("@emotion/react");
const GridContainer = _ref => {
  let {
    children,
    isNested,
    ...props
  } = _ref;
  return (0, _react2.jsx)(_helperComponents.GridContainerBase, (0, _extends2.default)({
    isNested: isNested
  }, (0, _utils.pickDataProps)(props)), children);
};
var _default = exports.default = (0, _composeStencilComponent.composeStencilComponent)({
  baseComponent: GridContainer,
  displayName: 'GridContainer',
  description: 'A container used to build layouts that align to a predetermined number of columns depending on viewport breakpoints.',
  propTypes: {
    isNested: _stencilReactDesc.PropTypes.bool.description("Sets container's spacing if the container is nested component")
  },
  defaultProps: {
    isNested: false
  }
});